import { render, staticRenderFns } from "./ProtocolUpsertModal.vue?vue&type=template&id=3be97ad8"
import script from "./ProtocolUpsertModal.vue?vue&type=script&lang=js"
export * from "./ProtocolUpsertModal.vue?vue&type=script&lang=js"
import style0 from "./ProtocolUpsertModal.vue?vue&type=style&index=0&id=3be97ad8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports